module.exports = __webpack_public_path__ + "media/bootstrap-icons/cloud-moon-a633b5c2.svg";